class Store {
  state = {
    filter: {
      eventCode: '',
      startDateFrom: '',
      startDateTo: '',
      endDateFrom: '',
      endDateTo: '',
      region: '',
      status: '',
      type: ''
    },

    userId: null,
    clientCode: null
  }

  mutations = {
    setFilter (state, filter) {
      state.filter = filter
    },

    setUserId (state, userId) {
      state.userId = userId
    },

    setClientCode (state, clientCode) {
      state.clientCode = clientCode
    }
  }
}
export default Store



// WEBPACK FOOTER //
// ./src/store/Store.js